export { STATUS_COLORS, PHASE_STATUS_COLOR } from './statusColors';

import React from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';
import { expertTheme } from './expertTheme';
import { expertDarkTheme } from './expertDarkTheme';

const expertLight = ThemeBlueprint.make({
  name: 'expert-light',
  params: {
    theme: {
      id: 'expert-light',
      title: 'Expert Light',
      variant: 'light',
      icon: React.createElement(LightIcon),
      Provider: ({ children }) =>
        React.createElement(UnifiedThemeProvider, {
          theme: expertTheme,
          children,
        }),
    },
  },
});

const expertDark = ThemeBlueprint.make({
  name: 'expert-dark',
  params: {
    theme: {
      id: 'expert-dark',
      title: 'Expert Dark',
      variant: 'dark',
      icon: React.createElement(DarkIcon),
      Provider: ({ children }) =>
        React.createElement(UnifiedThemeProvider, {
          theme: expertDarkTheme,
          children,
        }),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [expertLight, expertDark],
});
